import React from 'react';
import { useParams } from 'react-router-dom';

const CheckyourEmail = () => {
    const { email } = useParams();
    return (
        <div>
            Please check your email: {email}
        </div>
    );
};

export default CheckyourEmail;